import Vue from 'vue'
import './functions.js'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(relativeTime)
dayjs.extend(advancedFormat)

Vue.filter('fromNow', value => {
  return dayjs(value).fromNow();
});
Vue.filter('toHumanDate', function(value, format) {
  if (!value) return '';
  if(typeof format == 'undefined')
    format = 'DD/MM/YYYY';
  return dayjs(value).format(format);
});
Vue.filter('truncate', function(text, length, clamp){
  clamp = clamp || '...';
  let node = document.createElement('div');
  node.innerHTML = text;
  let content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
});
Vue.filter('numberFormat', function(value, decimals) {
  return window.numberFormat(value, decimals);
});
Vue.filter('moneyFormat', function(value, decimals) {
  return window.moneyFormat(value, decimals);
});
Vue.filter('lowercase', value => {
  return value.toLowerCase();
});
Vue.filter('slug', value => {
  value = value.replace(/^\s+|\s+$/g, ''); // trim
  value = value.toLowerCase();
  // remove accents, swap ñ for n, etc
  let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  let to   = "aaaaeeeeiiiioooouuuunc------";
  for (let i=0, l=from.length ; i<l ; i++) {
    value = value.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  value = value.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return value;
});
Vue.filter('statusToUCWords', value => {
  return window.stringToUCWords(value);
});
Vue.filter('capitalize', value => {
  return window.capitalize(value);
});

Vue.filter('numkeys', object => {
  return window.numkeys(object);
});

Vue.filter('nl2br', value => {
  return window.nl2br(value);
});
